import {
  DataTypeCoaching,
  DataTypeContent,
} from '@efdigital/ll-addon-data/data-types';
import { withDefaults } from '@warp-drive/legacy/model/migration-support';

import { DataTypeCoachingSharedResource } from '../types/coaching-shared-resource.ts';

/**
 * Local schema until `@efdigital/ll-addon-data` publishes CoachingSharedResource.
 * Registered alongside AllSchemas in the store.
 */
export const CoachingSharedResourceSchema = withDefaults({
  type: DataTypeCoachingSharedResource,
  legacy: true,
  identity: {
    kind: '@id',
    name: 'id',
  },
  fields: [
    {
      kind: 'belongsTo',
      name: 'coachingPartnership',
      type: DataTypeCoaching.CoachingPartnership,
      options: {
        async: true,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'resource',
      type: DataTypeContent.Resource,
      options: {
        async: true,
        inverse: null,
      },
    },
    {
      kind: 'attribute',
      name: 'user',
      type: 'string',
    },
    {
      kind: 'attribute',
      name: 'createdByUserId',
      type: 'string',
    },
    {
      kind: 'attribute',
      name: 'note',
      type: 'string',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'modified',
    },
  ],
});
